import React from "react";
import logoErlan from "../assets/logoerlan.png";
import sloganErlan from "../assets/slogan.png";
import "../styles/Header.css";

const Header = () => { 
  return (
    <header className="header">
      <img src={logoErlan} className="logoerlan" alt="Logo Erlan" />
      <img src={sloganErlan} className="sloganerlan" alt="Slogan Erlan" />
    </header>
  );
};

export default Header;